module.exports = __webpack_public_path__ + "media/slots_arthurs_camelot_ambiance_king.ae574419.mp3";